<div class="input-el" data-testid="avatar-container">
  <label for="avatarimg" name="avatar_btn" data-testid="avatar-btn">
    @if (avatarImg() != null) {
      <button type="button" class="ev-plain-button modify-avatar" (click)="deleteAvatarImg(); $event.preventDefault();" data-testid="avatar-delete-btn">
        <img src="assets/icons/dark/ui/cancel_icon.svg" alt="cancel icon" />
      </button>
    }

    @if (avatarImg() == null) {
      <div class="modify-avatar">
        <div class="plus-icon">+</div>
      </div>
    }

    <div class="avatar">
      @if (!avatarImg() && !avatarLoading()) {
        <img [src]="'/assets/icons/dark/ui/user_icon.svg'"
          alt="Default avatar" data-testid="avatar-default-img" />
      }

      @if (avatarLoading()) {
        <div class="avatar-loading" data-testid="avatar-loading-indicator"></div>
      }

      @if (avatarImg() && !avatarLoading()) {
        <div class="avatar-preview" data-testid="avatar-preview-img"
        [style.background-image]="'url(' + avatarImg() + ')'"></div>
      }
    </div>
  </label>
</div>

<input #avatarInput style="display: none;" name="avatar-upload" type="file" id="avatarimg"
  data-testid="avatar-upload-input"
  (change)="onAvatarChange($event)"
  accept="image/png,image/jpeg,image/jpg,image/webp,image/avif,image/gif,image/bmp,.heic,.heif" />

  @if (invalidImgType()) {
    <h6 class="invalid invalid-img" data-testid="avatar-type-error-text">
      {{ languageService.languageJSON.AccountDialog_Avatar_Error_Type }}
    </h6>
  }
  @if (invalidImgSize()) {
    <h6 class="invalid invalid-img" data-testid="avatar-size-error-text">
      {{ languageService.languageJSON.AccountDialog_Avatar_Error_Size }}
    </h6>
  }